import React, {Component} from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {Link, Redirect, Route } from 'react-router-dom';
import HeaderSample from "../common/headerSample";
import Button from 'react-bootstrap/Button';
import {_axios} from '../../plugins/axios';
import {WebcamCapture} from "../common/camera";
import { URL,USER } from "../../constants/constant";
import BarCodeModal from "../Order/barcode";
import ToasterComponent from "../common/toaster";
import Select from "react-select";
import Barcode from "react-barcode";
import PackageDetails  from "../common/packageDetails"
import { Modal } from "react-bootstrap";

class DropLabCollection extends Component{
  constructor(props){
    super(props);
    console.log(this.props)
    this.state = {
        userdata : USER.user,
        orderStatus : null,
        orderDetails : null,
        cameraToggle: false,
        messageSnack: "",
        showSnack: false,
        testDetails : null,
        takingSampleForTestId : null,
        testDetails: [],
        confirmShow: false,
        membersDetails : this.props.location.state ? this.props.location.state.membersData : localStorage.getItem('upsellMemberDetailsConfirm') ? JSON.parse(localStorage.getItem('upsellMemberDetailsConfirm')) : [],
        upsellMemberDetailsConfirm : localStorage.getItem('upsellMemberDetailsConfirm') ? false : true,
        modalShow : false,
        selectedSample : null,
        latitude : "0.0",
        longitude: "0.0",
        localAddress: null,
        orderToBeDropped : null,
        dropDownStatus: true,
        selectedSampleCo: null,
        billingId: null,
        showPackageInfo: false,
        loadPackageDetails: false,
        bulkSelectedDropAtLabsModal: false,
        bulkSelectedDropAtLabsUpdate: [],
        dependentIdRelatedOrders: [],
        updateDependantIdFor: 0,
        selectedOrderId: 0,
        latlongEventTriggerFunction : ev => {
            const that = this;
            console.log("lat long received event triggered",ev.detail);
        
            if (ev.detail !== null && ev.detail !== undefined) {
                const latlong = ev.detail.split(",");
                console.log("lat long split in an arr ",latlong);
                if(latlong !== null && latlong !== undefined) {
                    this.state.latitude = latlong[0];
                    this.state.longitude = latlong[1];
                    that.redirectOtpCustomer();
                } else {
                    that.showSnackbarFun("Location not received1, cannot continue", 2500)
                }   
            } else {
                that.showSnackbarFun("Location not received, cannot continue", 2500)
            }
            ev.stopImmediatePropagation();
        } 
    }
  }

    addEventListeners() {
        if (typeof android !== "undefined" && android !== null) {
            window.addEventListener('setLatLongFromApp', this.state.latlongEventTriggerFunction);
            console.log("addEventListeners : ", this.state.latlongEventTriggerFunction);
        }
    }

    cleanupListener() {
        if (typeof android !== "undefined" && android !== null) {
            window.removeEventListener('setLatLongFromApp', this.state.latlongEventTriggerFunction);
            console.log("cleanupListener : ", this.state.latlongEventTriggerFunction);
        }
    }

componentDidMount(){
    this.addEventListeners();
    this.getOrderDetails();
}

componentWillUnmount() {
    this.cleanupListener();
}

  
  showSnackbarFun(message, timeout){
    this.setState({
        messageSnacks: message,
        showSnackbar: true
    }, () => {
        this.toastComponent();
    })
    setTimeout(() => {
        this.setState({
            messageSnacks: "",
            showSnackbar: false,
        })
    }, timeout)
}

showAlert(message, timeout) {
    this.setState({
        messageSnack: message,
        showSnack: true
    });
    setTimeout(() => {
        this.setState({
            messageSnack: "",
            showSnack: false,
        })
    }, timeout);
}


toastComponent() {
    return <ToasterComponent show={this.state.showSnackbar ? this.state.showSnackbar : ''} message={this.state.messageSnacks ? this.state.messageSnacks : ''}></ToasterComponent>;
}

  checkBarCodes(){
    
    // this.state.sampleDetails.map(elem => {
    //     if(!elem.barcode){
    //         dropAtLabBtnDisabled  = true;
    //     }
    // })

}

getOrderDetails(){
    const that = this;
    let url = URL.dev_url;
     let route = url + 'getorders'
     let obj = {
        phleboId: this.state.userdata.phleboId
     }

     if(localStorage.getItem('orderTestDetails')){
        this.setState({
            testDetails :  JSON.parse(localStorage.getItem('orderTestDetails')),
            totalSamples : JSON.parse(localStorage.getItem('orderTestDetails')).length ,
        })
    }

    _axios.post(route,obj)
    .then(function (response) {
        localStorage.setItem('lab_technician_number',JSON.stringify(response.data.sampleTakenOrders[0].labDetails.AssignedLabtechnicianPhonenumber1));
        let relatedOrders = {}
        for(let order of response.data.sampleTakenOrders){
            if(!relatedOrders[order.dependantId]) relatedOrders[order.dependantId] = []
            relatedOrders[order.dependantId].push({ isSelected: true, ...order })
        }    
        that.setState({
                loadPackageDetails: true,
                dependentIdRelatedOrders: relatedOrders,
                orderDetails : response.data,
                sampleDetails :  response.data ? response.data.sampleTakenOrders : null,
            },()=>{
                that.checkBarCodes();
                that.checkSkipOtp();
            })
    }).catch(function (error) {
        console.log(error);
    })
    
}

showPackageInfoModal(){
    this.setState({
        showPackageInfo: !this.state.showPackageInfo
    })
}

handleCameraToggleMembers(element,index){
    const that = this;

    let testDetailsTemp =  this.state.membersDetails;
    
    if(testDetailsTemp && testDetailsTemp[index]){
        testDetailsTemp[index]["index"]=index;
        testDetailsTemp[index]["cameraToggle"]=true;
        testDetailsTemp[index]["b64"]=null;
        testDetailsTemp[index]["imageUploaded"] = null;
        
        console.log("testDetailsTemp",testDetailsTemp);

        this.setState({
            membersDetails : testDetailsTemp,
        },()=>{
            that.checkCameraForMembers(index)
        })
    }
    
 }

async markOrderDropped(sample) {

    if (typeof android !== "undefined" && android !== null) {
        console.log("Checking location in android");
        android.startLocationTracking();
    } else {
        this.redirectOtpCustomer();
    }
    // here ---
}

async redirectOtpCustomer(){
    // Phlebo Reached Patients home
    let DependantId = this.state.updateDependantIdFor
    if(this.state.dependentIdRelatedOrders[DependantId].length > 1){
        this.setState({bulkSelectedDropAtLabsModal : true, confirmShow: false, bulkSelectedDropAtLabsUpdate: this.state.dependentIdRelatedOrders[DependantId] })
    } else {
        const that = this;
        let url = URL.dev_url;
        let route = url + 'updateorders'
     
        let sampleOrdersToBeSubmitted = [this.state.orderToBeDropped];
        let obj = {
           access_token : "trialTest" || USER.access_token,
           currentStatusId : 7,
           requestNextStatusId : 8,
           phleboId: this.state.userdata.phleboId,
           sampleDetails : sampleOrdersToBeSubmitted,
           localAddress: sampleOrdersToBeSubmitted[0].hasDropDown ? this.state.localAddress : null, 
           lat: parseFloat(this.state.latitude).toFixed(4).toString(),
           long: parseFloat(this.state.longitude).toFixed(4).toString(),
        }
   
        let sampleOrderIds = [];
        sampleOrderIds.push(this.state.orderToBeDropped.orderId);
        localStorage.setItem("sampleOrderIds",JSON.stringify(sampleOrderIds));
        
   
        console.log("object ...",obj)
   
       _axios.post(route,obj)
       .then(function (response) {
           console.log("response",response.data);
           if (localStorage.getItem("failureLog")) {
               localStorage.removeItem("failureLog");
           }
           if(response.data.success){
               let x = '/otp/labs/';
               that.props.history.push(x);
           }
       }).catch(function (error) {
           console.log(error);
       })
    }
   
     
}


formatAMPM(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0'+minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
  }

callbackForMembers = (sampleValuesFromBarCode) => {
   let sampleDetailsTemp = this.state.sampleDetails;
   sampleDetailsTemp.map(element => {
       if(element.orderId == sampleValuesFromBarCode.orderId){
           element = sampleValuesFromBarCode;
       }
   })

   this.setState({
    sampleDetails : sampleDetailsTemp
   },()=>{
       this.checkBarCodes();
   })
 }


switchLocalAddress(location, order){

    this.setState({
        localAddress: location,
        selectedSampleCo: order,
    });

}

createOrder(elem) {


    const that = this;
    // let isSuccess = true;

    let route = "http://localhost:8080/lis/createLisOrder"
    let obj  = {
        phleboOrderId: elem.orderId,
        labId: elem.labDetails.AssignedLabId,
        appointmentId : elem.appointmentId,
        extraParams: {
            areaCode : this.state.localAddress.areaCode,
            token: this.state.localAddress.token
        }
    }

    // call the api 
    _axios.post(route, obj)
    .then(function (response) {
        console.log("response",response);

        if (response.data.isSuccess) {
    
            elem.orderCreatedInSpc = true;
            setTimeout(() => {
    
                that.setState({
                    dropDownStatus : false,
                    billingId: `${response.data.spcOrderDetails.spcOrderId}`
                });
            })
            if (localStorage.getItem("failureLog")) {
                localStorage.removeItem("failureLog");
            }
    
        } else {
    
            var map = new Map();
    
            if (localStorage.getItem("failureLog")) {
            
                let arr = JSON.parse(localStorage.getItem("failureLog"));
    
                let newArr = arr.map(i => i[0]);
    
                if (newArr.includes(elem.orderId)) {
    
                    arr.forEach(i => {
    
                        if (i[0] === elem.orderId) {
                            if (i[1]<=1 ) {
                                that.showAlert("Try Again!", 2500);
                                i[1]++;
        
                                map.set(i[0],i[1]);
                                
                                
                            } else {
        
                                elem.orderCreatedInSpc = true;
                                
    
                                that.showAlert("Go with the normal flow!", 4000);
                                setTimeout(() => {

                                    that.setState({
                                        billingId : null,
                                        dropDownStatus: false
                                    });
                                });  
                             
                            }
                        } else {
                            map.set(i[0],i[1]);
                        }
                    });
                } else {

                    that.showAlert("Try Again!", 2500);
                    arr.push([elem.orderId, 1]);
                    arr.forEach(i => {
                        map.set(i[0],i[1]);
                    });
                }
    
                localStorage.setItem("failureLog",JSON.stringify([...map]));
    
            } else {
                that.showAlert("Try Again!", 2500);
                map.set(elem.orderId, 1);
                
                localStorage.setItem("failureLog", JSON.stringify([...map]));
            }
    
        }

        // if(response.data.success){
        //     let x = '/otp/labs/';
        //     that.props.history.push(x);
        // }
    }).catch(function (error) {
        
        throw error;
    });


    // if response is success 
     // disable the dropdown button
     // check for enabling barcode button and submit.

    // if it is not --- else 

     // give it an another try
     // if(!success ) please try again
        
    // if(!success > 3) let him go by usual flow

    // response {
    //     success: true,
    //     orderId: phleboOrderId,
    //     spcOrderId : billID
    // }
 

}

checkSkipOtp () {
    let skip = false
    if (skip) {
        if (sampleData !== null) {
            sampleData = sampleData.filter(i => i.orderStatus.currentStatusId === 6)

            this.setState({
                sampleDetails: sampleData
            })
        }
    }
}

showConfirmation () {

    let that = this;
    
    if (that.state.confirmShow) {
        return <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={that.state.confirmShow}
        onHide={() => {this.setState({confirmShow : false})}}
        >
        <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
                Confirmation Required
            </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{padding:'1px', overflowY: "auto",display: "flex", flexDirection: "column", rowGap: "1px"}}>
            <Row>
                <span className="px-5">Please confirm you are depositing the sample at the following processing center  -  <br/> <span><br/></span>
                <Col>
                    <Row> <b className="m-r-1">Lab Name:</b> <span>&nbsp; </span> {this.state.orderToBeDropped.labDetails.AssignedLab}</Row>
                    <Row><b className="m-r-1">Address:</b> <span>&nbsp; </span> {this.state.orderToBeDropped.labDetails.AssignedLabAddress}</Row>

                    <Row><b className="m-r-1">Pincode:</b> <span> &nbsp;</span> {this.state.orderToBeDropped.labDetails.AssignedLabPincode}</Row>

                </Col>
                </span>
            </Row>
            
               
            <Row className = "m-b-2 p-4">
                <Col className = 'p-1'>
                    <Button variant="danger" size="sm" block className="m-2 p-r-1 p-l-1" onClick={() => {this.setState({confirmShow : false})}}>
                        Cancel
                    </Button>
                </Col>
                <Col  className = 'p-1'>
                    <Button variant="primary" size="sm" block className="m-2 p-r-1 p-l-1" onClick={()=> this.markOrderDropped()}>
                        Confirm
                    </Button>
                </Col>

            </Row>
                
                
            
        
            
        </Modal.Body>
    </Modal>
    }
        
}

markBulkDropAtLabsUpdate(id, e){
    const relatedOrders = this.state.bulkSelectedDropAtLabsUpdate
    for(let data of relatedOrders){
        if(data.orderId == id){
            data.isSelected = !data.isSelected
            break
        }
    }
    this.setState({ bulkSelectedDropAtLabsUpdate: relatedOrders })
}

async updateDropAtLabsOrderBulk(){
    try {
        this.setState({bulkSelectedDropAtLabsModal: false})
        let url = URL.dev_url;
        let route = url + 'updateorders'
        let sampleOrderIds = [];
        let sampleDetailsArr = []
        for(let order of this.state.bulkSelectedDropAtLabsUpdate){
            if(!order.isSelected) continue
            sampleDetailsArr.push(order)
            sampleOrderIds.push(order.orderId);
        }
        let obj = {
            access_token : "trialTest" || USER.access_token,
            currentStatusId : 7,
            requestNextStatusId : 8,
            phleboId: this.state.userdata.phleboId,
            sampleDetails : sampleDetailsArr,
            localAddress: null, 
            lat: parseFloat(this.state.latitude).toFixed(4).toString(),
            long: parseFloat(this.state.longitude).toFixed(4).toString(),
            }
        let response = await _axios.post(route,obj)
        if (localStorage.getItem("failureLog")) {
            localStorage.removeItem("failureLog");
        }
        if(!response.data.success){
                throw new Error("Something went wrong!!!")
        }
        localStorage.setItem("sampleOrderIds",JSON.stringify(sampleOrderIds));
        this.props.history.push('/otp/labs/');
        
    } catch (error) {
        console.log(error)
    }
    
}

showMemberDetails(){
    console.log("details",this.state.sampleDetails);
    return( 
        <div className="p-10">
            <Modal
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.bulkSelectedDropAtLabsModal}
                    onHide={() => {this.setState({bulkSelectedDropAtLabsModal : false})}}
                    >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            Update other tests as well for this customer ({this.state?.orderDetails?.pendingOrders?.[0]?.patientDetails?.[0]?.name})?
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body style={{padding:'1px', overflowY: "auto",display: "flex", flexDirection: "column", rowGap: "1px", marginTop: "5px"}}>
                        <Row style={{"display": "flex", "flexDirection": "column", "marginLeft": "20px"}}>
                            {this.state.bulkSelectedDropAtLabsUpdate.map(data => (
                                data.orderId != this.state.selectedOrderId && <div style={{display: "flex"}}>
                                    <input
                                        type="checkbox"
                                        id={data.orderId}
                                        name={data.orderId}
                                        onChange={(e) => this.markBulkDropAtLabsUpdate(data.orderId, e)}
                                        checked={data.isSelected}
                                    />
                                    <label style={{marginLeft: "5px"}} for={data.orderId}>{`${data.tests[0].testName} (# ${data.appointmentId})`}</label>
                                </div>
                                
                            ))}
                        </Row>
                            
                        
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={() => this.updateDropAtLabsOrderBulk()}>Save changes</Button>
                    </Modal.Footer>
                </Modal>
        {
                this.state.sampleDetails ? this.state.sampleDetails.map((elem,index) => (
                    <div className="p-10">
                      <div className="order-details-dashboard" key={index}>
                          
                          <div>
                    <div className="header-sample">
                        <Container>
                                <Row>
                                    <Col xs={12} md={12} className="p-10">
                                        <div className="font-size-ml bold">
                                            Sample to be Dropped at Center
                                        </div>
                                    </Col>
                                </Row> 
                                <Row>
                                    <Col xs={12} md={12} className="p-b-10">
                                        <div className="font-size-smd bold">
                                            { (elem.labDetails.AssignedLab != null) ? elem.labDetails.AssignedLab : ""}
                                        </div>
                                    </Col>
                                </Row> 
                                <Row>
                                    <Col xs={12} md={12} className="p-b-5">
                                        <div className="font-size-smd">
                                         <i className="fa fa-map-marker width-5 p-l-2 p-b-10" aria-hidden="true"></i>
                                        Lab Address
                                        </div>
                                        <div className="font-size-smd bold">
                                            { (elem.labDetails.AssignedLabAddress != null) ? elem.labDetails.AssignedLabAddress : ""}
                                        </div>
                                    </Col>
                                </Row>
                                {elem.hasDropDown && !elem.orderCreatedInSpc &&
                                <Row> 
                                    <Col xs={12} md={12} className="p-b-5">
                                        <div className="font-size-smd p-b-5 bold">Select lab Location: </div>
                                        <Select 
                                        isDisabled={!this.state.dropDownStatus}
                                        defaultValue={this.state.localAddress}
                                        isSearchable = {true}
                                        style={{width: '100px'}}
                                        onChange={(event) => this.switchLocalAddress(event, elem)}
                                        options={elem.labDetails.AdditionalLocations} />
                                    </Col>
                                    <Col>
                                        <Button  size="lg" block className="btn btn-info btn-outline-info  bg-transparent border-curve-5 margin-auto" disabled={this.state.selectedSampleCo === null || (this.state.selectedSampleCo && this.state.selectedSampleCo.orderId != elem.orderId)} onClick={()=> this.createOrder(elem)}>
                                            Create Order
                                        </Button>
                                    </Col>
                                </Row>

                                }
                        </Container>
                    </div>

                </div>
                
                            <Container>
                                <Row className="m-10 sample-order-header-labs">
                                    <Col xs={12} md={12}>
                                        <div  className="font-size-sm uppercase">
                                            Order Id
                                        </div>
                                        <div className="font-size-smd bold">
                                            {elem.orderId}
                                        </div>
                                    </Col>
                                    
                                </Row>
                                {elem.spcOrderId  &&
                                <div> 
                                    
                                    <Row className="m-10 sample-order-header-labs">
    
                                    <Col xs={12} md={12}>
                                        <div  className="font-size-sm uppercase">
                                            {`Order Id of ${elem.labDetails.AssignedLab}`}
                                        </div>
                                        <Barcode value={elem.spcOrderId} />
                                            
                                        {/* <div className="font-size-smd bold">
                                            {this.state.billingId}
                                        </div> */}
                                        
                                    </Col>
                                    
                                    
                                    </Row> 
                                

                                </div>

                                }
                                <Row className="p-l-10 p-r-10 p-b-10">
                                    <Col xs={6} md={6}>
                                        <div  className="font-size-smd uppercase">
                                            Name
                                        </div>
                                        <div className="font-size-smd bold">
                                            {elem.patientDetails[0].name}
                                        </div>
                                    </Col>
                                    <Col xs={6} md={6}>
                                        <div  className="font-size-smd">
                                           Time
                                        </div>
                                        <div className="font-size-smd bold">
                                         {this.formatAMPM(new Date(elem.orderDateTime))}
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} md={12}>
                                            <div className="p-l-10 p-r-10 p-t-10">   
                                                <div className="font-size-smd">
                                                <i className="fa fa-flask width-5 p-l-2 p-b-10" aria-hidden="true"></i>
                                                    Test Name
                                                    <button className="btn btn-default -m-t-10" onClick={() => this.showPackageInfoModal()}><svg fill="#000000" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 50 50" width="20px" height="20px">    <path d="M25,2C12.297,2,2,12.297,2,25s10.297,23,23,23s23-10.297,23-23S37.703,2,25,2z M25,11c1.657,0,3,1.343,3,3s-1.343,3-3,3 s-3-1.343-3-3S23.343,11,25,11z M29,38h-2h-4h-2v-2h2V23h-2v-2h2h4v2v13h2V38z"/></svg></button>
                                                </div>
                                                <div className="font-size-smd bold">
                                                    <ol>
                                                            {
                                                               elem.tests ?  elem.tests.map((element,index) => (
                                                                    <li key={index}>
                                                                        <div className="p-b-5">
                                                                                {element.testName}
                                                                        </div>
                                                                     </li>
                                                               )) : ''
                                                            }
                                                     
                                                    </ol> 
                                                </div>
                                            </div>
                                            <div className="p-l-10 p-r-10 p-t-10">   
                                                <div className="font-size-smd">
                                                <i className="fa fa-flask width-5 p-l-2 p-b-10" aria-hidden="true"></i>
                                                    Test Details
                                                </div>
                                                <div className="font-size-smd bold">
                                                    <ol>
                                                            {
                                                               elem.tests ?  elem.tests.map((element,index) => (
                                                                    <li key={index}>
                                                                        <div className="p-b-5">
                                                                                {element.testDetails}
                                                                        </div>
                                                                     </li>
                                                               )) : ''
                                                            }
                                                     
                                                    </ol> 
                                                </div>
                                            </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} md={12}>
                                    <div className="p-10">   
                                        <div className="font-size-smd">
                                            <i className="fa fa-map-marker width-5 p-l-2 p-b-10" aria-hidden="true"></i>
                                            Customer Address
                                        </div>
                                        <div className="font-size-smd bold p-l-15">
                                            {
                                                elem.patientDetails[0].addressLine1 ? <span> {elem.patientDetails[0].addressLine1}, </span> : '' 
                                            }
                                            {   
                                                elem.patientDetails[0].addressLine2 ? <span> {elem.patientDetails[0].addressLine2}, </span> : ''
                                            }
                                            { elem.patientDetails[0].landmark ? elem.patientDetails[0].landmark : '' }  -  { elem.patientDetails[0].pincode ? elem.patientDetails[0].pincode : ''}
                                        </div>
                                    </div>
                                </Col>
                                </Row>
                                
                                <Row>
                                <div  className="width-100">
                                    <div  className="display-flex flex-wrap justify-content-center p-t-10">
                                        
                                                <div>
                                                    
                                                      <div className="width-66 margin-auto p-b-10">
                                                         <div>
                                                             <button type="button" className="btn btn-outline-info margin-auto" disabled={elem.hasDropDown && !elem.orderCreatedInSpc} onClick={()=>this.setState({modalShow:true, selectedSample:elem})}>
                                                                 <span className="font-size-10px" >
                                                                     <i className="fa fa-search p-r-5" aria-hidden="true"></i>
                                                                     Scan Barcode
                                                                 </span>
                                                             </button>   
                                                         </div>
                                                      </div>
                                                   
                                                     <div className="text-align-center">  
                                                       {elem.barcode ?
                                                         <div>
                                                            <i className="fa fa-barcode font-size-lg" aria-hidden="true"></i>
                                                            <div className="font-size-smd bold">
                                                                {elem.barcode}
                                                            </div>
                                                         </div>
                                                        : ''}
                                                     </div>

                                                    
                                                    <div className="display-flex font-size-smd bold p-b-10">
                                                        <Button variant="primary" size="lg" block className="border-curve-10 margin-auto" disabled={elem.barcode == null} onClick={()=> this.setState({
                                                            confirmShow: true,
                                                            orderToBeDropped: elem,
                                                            updateDependantIdFor: elem.dependantId,
                                                            selectedOrderId: elem.orderId
                                                        })}>
                                                            Submit Sample at Lab
                                                        </Button>
                                                    </div>
                                                

            
                                                </div>
                                               
                                        
                                    </div>
                                </div>
                                </Row>      
                            </Container>
                            </div>

                    </div>
                    )
                    ): ''
        }
        
       </div>
       
       )
}


  render(){
    return(
        
        <div>
            {this.showMemberDetails()}
            {this.state.showSnack ? <div className="snackbar show">{this.state.messageSnack}</div> : ''}
                {this.state.modalShow && <BarCodeModal
                            show={this.state.modalShow}
                            dataparenttochild={this.state.selectedSample}
                            parentCallback={(result) => this.callbackForMembers(result)}
                            onHide={() => this.setState({modalShow:false})}
                        />}
            {this.showConfirmation()}
        {this.state.loadPackageDetails && < PackageDetails showPackageInfo={this.state.showPackageInfo} showPackageInfoModal={() => this.showPackageInfoModal()} appointmentId={this.state.orderDetails.sampleTakenOrders[0].appointmentId} packageName={this.state.orderDetails.sampleTakenOrders[0].tests[0].testName} />}
        </div>
    )
    }
}
export default DropLabCollection;